import * as React from "react";
import UploadAndShare from "../../Components/UploadAndShare";

export const UploadAndShareComponent = () => {
  return (
    <>
      <UploadAndShare title={"Upload & Share"} />
    </>
  );
};

export default UploadAndShareComponent;
